/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum GetCaseVersionsResult {
  Error = 0,
  Success = 1,
  InvalidCompany = 2,
  InvalidClearanceCaseId = 3,
}
